import * as React from 'react'
import ReadOnlyView from '../../core/components/FeatureViews/ReadOnlyView'
import {Feature} from '../../core/models'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'

class AppReadOnlyView extends ReadOnlyView {
  getGoogleLink(feature: Feature, coordinatesOnly?: boolean): JSX.Element | null {
    const geom = feature.getGeometry()
    if (geom != null) {
      const coordinates = geom.getCenter().trans(CoordinateSystem.GEOGRAPHIC).getCoordinates()
      let link = `https://maps.google.com/maps?z=18&q=${coordinates[1]},${coordinates[0]}`
      if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        //check for cordova
        // window.open("google.navigation:q=23.3728831,85.3372199&mode=d" , '_system');
        link = `geo:${coordinates[1].toFixed(6)},${coordinates[0].toFixed(6)}?q=${coordinates[1].toFixed(
          6
        )},${coordinates[0].toFixed(6)}`
        return (
          <a
            href="javascript:;"
            onClick={() => {
              window.open(link, '_system')
            }}
          >{`${coordinatesOnly ? '' : 'Навигирай до: '}${coordinates[1].toFixed(5)}, ${coordinates[0].toFixed(5)}`}</a>
        )
      }
      return (
        <a href={link} target="_blank" rel="noreferrer">{`${
          coordinatesOnly ? '' : 'Навигирай до: '
        }${coordinates[1].toFixed(5)}, ${coordinates[0].toFixed(5)}`}</a>
      )
    }
    return null
  }
}

export default AppReadOnlyView
